import { createSlice } from '@reduxjs/toolkit';

// slice to hold enrollment lists for dropdown selections
const initialState = {
    devices: [],
    questionnaires: [],
    programs: [],
    content: [],
    patients: [],
    previousEnrollments: []
};

const patientEnrollmentSlice = createSlice({
    name: "enrollmentLists",
    initialState,
    reducers: {
        resetListState: (state) => {
            return initialState;
        },
        setListValue: (state, action) => {
            const { key, value } = action.payload;
            state[key] = value;
        },
        
    }
});

export const {
    resetListState,
    setListValue,
  } = patientEnrollmentSlice.actions;
  
  export default patientEnrollmentSlice.reducer;